import { useEffect , useState } from 'react'
// import { decodeStorage } from 'functions/storageBase64'

const useCartLocal = () => {

    const [ listEvents, setListEvents ] = useState(false)

    // const localEvents = decodeStorage('localCartEvents')
    const localEvents = window.localStorage.getItem('localCartEvents')
    const localCartEvents = localEvents ? JSON.parse(localEvents) : []
    

    // va por servicio de Carrito
    const [ respLocalList, setRespLocalList ] = useState(false)
    const [ respList, setRespList ] = useState(false)
    const localListCarts = async ( event_id ) => {
        try {
            // console.log('eventID: ',event_id)
            // console.log('localCartEvents: ',localCartEvents)
            const response = await localCartEvents.filter( event => Number(event?.gift_table_id) === Number(event_id) )
            // console.log('response: ',response)
            if(response?.length >= 1){
                setRespList(response)
            }else{
                setRespList(undefined)
            }

        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }
    useEffect(()=>{
        if(respList?.length >= 1){
            setRespLocalList(respList)
        }else if(respList === undefined){
            setRespLocalList([])
        }
    },[respList])


    // crea el carrito con el post
    const [ respCreateCartL, setRespCreateCartL ] = useState(false)
    const localCreateCart = async ( eventID, payload ) =>{
        const event_id = String(eventID)
        const card_id = Number(event_id + 10)

        try {
            const newResponse = [{
                cart_id: card_id,
                gift_table_id: Number(event_id),
                guest_name: null,
                congrats_message: null,
                congrats_to_celebrated_id: null,
                products: [{
                    product_sears_id: payload?.product_sears_id,
                    variant_sears_id: payload?.variant_sears_id,
                    ean: payload?.ean,
                    sku: payload?.sku,
                    children_sku_sears: payload?.children_sku_sears,
                    division_sears_id: payload?.division_sears_id,
                    is_market_place: payload?.is_market_place,
                    quantity: payload?.quantity,
                    quantity_required: payload?.quantity_required || payload?.quantity,
                    category_sears_ids: payload?.category_sears_ids
                }]
            }]

            const addLocalEvents = window.localStorage.getItem('localCartEvents')
            const addEvents = addLocalEvents ? JSON.parse(addLocalEvents) : []
            if(addEvents?.length === 0){
                const result = JSON.stringify(newResponse)
                window.localStorage.setItem('localCartEvents', result)
                setRespCreateCartL(newResponse)
            
            }else if(addEvents?.length >= 1){
                const cartSinEvent = addEvents.filter( event => Number(event?.cart_id) !== Number(event_id) )
                cartSinEvent.push(newResponse[0])

                const result = JSON.stringify(cartSinEvent)
                window.localStorage.setItem('localCartEvents', result)
                setRespCreateCartL(newResponse)
            }
            
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }


    // agrega productos con el patch
    const [ respAddProductL, setRespAddProductL ] = useState(false)
    const localAddProducts = async ( eventID, payload ) =>{
        const cart_id = String(eventID)
        const addLocalEvents = window.localStorage.getItem('localCartEvents')
        const addEvents = addLocalEvents ? JSON.parse(addLocalEvents) : []
        
        try {
            const response = await localCartEvents.filter( event => Number(event?.cart_id) === Number(cart_id) )
            const products = response[0]?.products
            products.push(payload)

            const newResponse = [{
                ...response[0],
                products
            }]

            if( products.find(producto => producto?.product_sears_id !== payload?.product_sears_id ) ){
                if(addEvents?.length === 0){
                    const result = JSON.stringify(newResponse)
                    window.localStorage.setItem('localCartEvents', result)
                    setRespAddProductL(newResponse)
                }
                else if(addEvents?.length >= 1){
                    const cartSinEvent = addEvents.filter( event => Number(event?.cart_id) !== Number(cart_id) )
                    cartSinEvent.push(newResponse[0])
                    
                    const result = JSON.stringify(cartSinEvent)
                    window.localStorage.setItem('localCartEvents', result)
                    setRespAddProductL(newResponse)
                }
            }
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }



    // elimina productos con el delete
    const [ respDeleteProductL, setRespDeleteProductL ] = useState(false)
    const localDeleteProducts = async ( eventID, productID, productSKU  ) =>{
        const cart_id = String(eventID)
        const removeLocalEvents = window.localStorage.getItem('localCartEvents')
        const removeEvents = removeLocalEvents ? JSON.parse(removeLocalEvents) : []

        const responseDelete = {
            productID, 
            productSKU
        }
        
        try {
            const response = await removeEvents.filter( event => Number(event?.cart_id) === Number(cart_id) )
            
            const productsFilter = response[0]?.products
            const products = productsFilter.filter(product => (product.product_sears_id !== productID || product.children_sku_sears !== productSKU))

            const newResponse = [{
                ...response[0],
                products
            }]

            if( products.find(producto => producto?.product_sears_id !== productID ) ){
                
                if(removeEvents?.length === 0){
                    const result = JSON.stringify(newResponse)
                    window.localStorage.setItem('localCartEvents', result)
                    setRespDeleteProductL(responseDelete)
                }
                else if(removeEvents?.length >= 1){
                    const cartSinEvent = removeEvents.filter( event => Number(event?.cart_id) !== Number(cart_id) )
                    cartSinEvent.push(newResponse[0])
                    
                    const result = JSON.stringify(cartSinEvent)
                    window.localStorage.setItem('localCartEvents', result)
                    setRespDeleteProductL(responseDelete)
                }
            }else if(newResponse[0]?.products?.length === 0){
                    const newResp = removeEvents.filter(del => del?.gift_table_id !== newResponse[0]?.gift_table_id)
                    const result = JSON.stringify(newResp)
                    window.localStorage.setItem('localCartEvents', result)
                    setRespDeleteProductL(responseDelete)
                }

        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }


    return{
        localListCarts,
        respLocalList,
        localCreateCart,
        respCreateCartL,
        localAddProducts,
        respAddProductL,
        localDeleteProducts,
        respDeleteProductL,
        setLastEventsL: setListEvents
    }
}

export default useCartLocal